import type { SVGProps } from 'react';

export const KarmaPoint = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 10 10" {...props}>
      <path
        d="M5.59195 1.51426C6.08401 2.85659 7.14182 3.91436 8.48415 4.40642L9.51487 4.78422C9.71553 4.8578 9.71553 5.14158 9.51487 5.21511L8.51803 5.58052C7.15422 6.08046 6.07946 7.15519 5.57955 8.51904L5.21414 9.51587C5.14061 9.7165 4.85683 9.7165 4.78325 9.51587L4.41785 8.51904C3.91794 7.15519 2.84317 6.08046 1.47936 5.58052L0.482528 5.21511C0.281866 5.14158 0.281866 4.8578 0.482528 4.78422L1.47936 4.41882C2.84317 3.91892 3.91794 2.84419 4.41785 1.48034L4.78325 0.483505C4.85683 0.282842 5.14061 0.282842 5.21414 0.483505L5.59195 1.51426Z"
        fill="currentColor"
      />
    </svg>
  );
};
